import type { HTMXEvent } from '../types';
import { loadingHandler } from './handlers/loading';

document.addEventListener('htmx:beforeRequest', (event: HTMXEvent) => {
    loadingHandler(event);
});
